import React, { useState } from "react";
import { Sparkles, Film, Wand2, Mail, MessageSquare, Search, CheckCircle2, X } from "lucide-react";
import api from "@/lib/api";

const steps = [
  { icon: Sparkles, color: "#7C3AED", title: "Meet Optimus Prime", desc: "Your AI marketing strategist. Ask anything — content ideas, captions, growth tips." },
  { icon: Film, color: "#8B5CF6", title: "Video Editing", desc: "Submit a video and we'll polish it for every platform automatically." },
  { icon: Wand2, color: "#3B82F6", title: "AI Generation", desc: "Generate posts, ads, and full videos from a single prompt." },
  { icon: Mail, color: "#06B6D4", title: "Email", desc: "Drag-and-drop campaigns, AI-written copy, smart segmentation." },
  { icon: MessageSquare, color: "#14B8A6", title: "SMS", desc: "Reach customers instantly with high-converting text campaigns." },
  { icon: Search, color: "#10B981", title: "SEO", desc: "Track AI visibility across ChatGPT, Perplexity, and Google AI." },
  { icon: CheckCircle2, color: "#10B981", title: "You're All Set!", desc: "Optimus Prime is ready to power your marketing engine." },
];

const TourModal = ({ onClose }) => {
  const [step, setStep] = useState(0);
  const s = steps[step];
  const Icon = s.icon;

  const finish = async () => {
    try { await api.post("/onboarding/tour-complete"); } catch (e) {}
    onClose();
  };

  const next = () => {
    if (step === steps.length - 1) finish();
    else setStep(step + 1);
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4 animate-fade-in" data-testid="tour-modal">
      <div className="bg-white rounded-2xl max-w-md w-full overflow-hidden shadow-2xl">
        <div className="h-1.5 gradient-tour" />
        <div className="p-8">
          <div className="flex items-start justify-between mb-6">
            <div className="w-14 h-14 rounded-xl flex items-center justify-center" style={{ backgroundColor: s.color + "20" }}>
              <Icon style={{ color: s.color }} size={28} />
            </div>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600" data-testid="tour-close-btn"><X size={20} /></button>
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">{s.title}</h2>
          <p className="text-gray-600 leading-relaxed mb-8">{s.desc}</p>
          <div className="flex items-center gap-1.5 mb-6">
            {steps.map((_, i) => (
              <span key={i} className={`h-1.5 rounded-full transition-all ${i === step ? 'w-8 bg-[#7C3AED]' : i < step ? 'w-1.5 bg-[#7C3AED]' : 'w-1.5 bg-gray-200'}`} />
            ))}
          </div>
          <div className="flex items-center justify-between">
            <span className="text-xs text-gray-500 font-medium">{step + 1} of {steps.length}</span>
            <div className="flex gap-2">
              {step > 0 && <button onClick={() => setStep(step - 1)} className="op-btn-secondary text-sm py-2" data-testid="tour-back-btn">Back</button>}
              <button onClick={next} className="op-btn-primary text-sm py-2" data-testid="tour-next-btn">
                {step === steps.length - 1 ? "Get Started" : "Next"} →
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TourModal;
